// extracted by mini-css-extract-plugin
export default {"pulsatingButton":"mobile_app_pulsatingButton__PkDvZ","pulse":"mobile_app_pulse__drWK3"};